export const LIST_LANGUAGE_DATA = "LIST_LANGUAGE_DATA"
export const LIST_LANGUAGE_DATA_SUCCESS = "LIST_LANGUAGE_DATA_SUCCESS"
